import type React from 'react';
import styled from '@emotion/styled';

export type TagDetailsSectionsContainerProps = {
  children: React.ReactNode;
};

/** Vertical stack that spaces out section cards — mirrors the frontend Tab.Panes.Container. */
export const TagDetailsSectionsContainer = ({ children }: TagDetailsSectionsContainerProps) => (
  <Root>{children}</Root>
);

TagDetailsSectionsContainer.displayName = 'TagDetails.SectionsContainer';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 0;
`;
